import React from 'react'
import {Button, Label, Media} from 'reactstrap'
import {AvFeedback, AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation'
import SFLogo from '../../images/sf-logo-horizontal.png'

let RequestPasswordResetForm = ({onValidSubmit, onInvalidSubmit}) =>
    <AvForm onValidSubmit={onValidSubmit}
            onInvalidSubmit={onInvalidSubmit}
            className="col-md-6 col-sm-10 text-left">

        <div className="text-center">
            <Media object src={SFLogo} alt="SureFire Ag Logo" className="col-10 mb-4"/>
            <h2 className="mb-2">Forgot Your <strong>Marksman</strong> Password?</h2>
            <h3 className="mb-4">That's Ok!</h3>
            <p className="mb-4 text-left">
                Enter the email address associated with your account and we'll send you
                a link to reset your password. <strong>You'll be up and running in no time.</strong>
            </p>
        </div>

        <AvGroup>
            <Label for="email">Email Address</Label>
            <AvInput name="email"
                     placeholder="you@email.com"
                     type="email"
                     autoComplete="email"
                     required/>
            <AvFeedback>Please enter a valid email address.</AvFeedback>
        </AvGroup>

        <AvGroup>
            <Button className="col-sm-10 offset-sm-2 col-md-8 offset-md-4 col-lg-6 offset-lg-6">
                Request Password Reset
            </Button>
        </AvGroup>
    </AvForm>

export default RequestPasswordResetForm



// WEBPACK FOOTER //
// ./src/components/ui/RequestPasswordResetForm.js